module.exports = __webpack_public_path__ + "static/media/testing-white-small.cf4ace72.svg";